import type { ActionContext } from 'vuex'

import type { ActionClass, AppState } from '../../../models'

import { APP_CONSTS } from '../app.consts'

export class SetMenuCollapsedAction implements ActionClass {
  static execute(
    this: void,
    { commit }: ActionContext<AppState, any>,
    menuCollapsed: boolean,
  ): void {
    commit(APP_CONSTS.mutations.setMenuCollapsed, menuCollapsed)
  }
}
